import script from "./StorageManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./StorageManagement.vue?vue&type=script&setup=true&lang=js"

import "./StorageManagement.vue?vue&type=style&index=0&id=19e11e44&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e11e44"]])

export default __exports__